import { ItemContainer } from './BodyInfoItem.styles';
import { BodyInfoItemProps } from './BodyInfoItem.types';

export const BodyInfoItem = (
  { title, value }: BodyInfoItemProps,
) => (
  <ItemContainer
    display="flex"
    flexDirection={{ sm: 'column', lg: 'row' }}
    gridGap={{ sm: '0.5rem', lg: '0.313rem' }}
    alignItems={{ sm: 'flex-start', lg: 'center' }}
    flexWrap="wrap"
    fontSize={{ sm: '0.75rem', lg: '0.875rem' }}
  >
    <strong>{title}</strong>
    {' '}
    {value}
  </ItemContainer>
);
